<template>
  <!-- fullHeight 为 false 时取消 min-height: 100vh，高度由内容撑开 -->
  <div class="bg" :style="fullHeight ? {} : { minHeight: 'auto' }">
    <div class="title">联系我们</div>
    <div class="box">
      <div class="smallTit">渠道合作</div>
      <el-form
        :inline="true"
        :model="form"
        :rules="formRules"
        ref="formInline"
        class="demo-ruleForm"
        label-position="top"
      >
        <el-row>
          <el-col :span="9">
            <el-form-item label="姓名" prop="name" style="width: 100%;">
              <el-input
                placeholder="请输入内容"
                v-model="form.name"
                style="width: 100%;"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <div style="height:20px"></div>
          </el-col>
          <el-col :span="9">
            <el-form-item label="企业名称" prop="company" style="width: 100%;">
              <el-input placeholder="请输入内容" v-model="form.company">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="9">
            <el-form-item label="电话" prop="telephone" style="width: 100%;">
              <el-input placeholder="请输入内容" v-model="form.telephone">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <div style="height:20px"></div>
          </el-col>
          <el-col :span="9">
            <el-form-item label="职位" prop="position" style="width: 100%;">
              <el-input placeholder="请输入内容" v-model="form.position">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item prop="content" label="需求描述" style="width: 100%;">
          <el-col :span="24">
            <el-input
              type="textarea"
              :rows="6"
              placeholder="请输入内容"
              v-model="form.content"
            >
            </el-input>
          </el-col>
        </el-form-item>
        <el-form-item style="width: 100%;">
          <el-button class="btn" @click="submitForm">提交</el-button>
          <p class="content">
            为更好地为您提供服务，请认真填写以上内容。我们会按照相关法律规定，保护您的个人隐私，并尽快与您联系。
          </p>
          <div style="height: 20px;"></div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "ContactWe",
  props: {
    // 是否让组件占满一屏高度（min-height: 100vh），默认 true
    fullHeight: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      form: {},
      formRules: {
        name: [
          {
            required: true,
            message: "姓名不能为空",
            trigger: "blur"
          }
        ],
        telephone: [
          {
            required: true,
            message: "电话不能为空",
            trigger: "blur"
          }
        ],
        company: [
          {
            required: true,
            message: "企业名称不能为空",
            trigger: "blur"
          }
        ],
        position: [
          {
            required: true,
            message: "职位不能为空",
            trigger: "blur"
          }
        ],
        content: [
          {
            required: true,
            message: "需求描述不能为空",
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    submitForm() {
      this.$refs["formInline"].validate(valid => {
        if (valid) {
          // 构建表单数据
          const formData = {
            userName: this.form.name,
            enterpriseName: this.form.company,
            position: this.form.position,
            phone: this.form.telephone,
            requirementDescription: this.form.content
          };
          // 发送表单数据到服务器
          axios
            .post(
              `https://webapi.unitednev.cn/system/feedback/websiteAdd`,
              formData,
              {
                headers: {
                  "Content-Type": "application/json"
                }
              }
            )
            .then(response => {
              // 处理成功的响应
              console.log(formData);
              console.log(response.data);
              this.$message.success("提交成功！");
              // 刷新当前页面
              window.location.reload();
            })
            .catch(error => {
              // 处理错误
              console.log(formData);
              console.error(error);
              this.$message.success("提交失败！");
            });
        }
      });
    }
  }
};
</script>

<style scoped>
.bg {
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(to bottom, #f1fbff, #fbfeff);
  /* text-align: center; */
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-top: 100px;
  padding-bottom: 50px;
}
.box {
  width: 60%;
  height: 75%;
  background-color: #fff;
  padding: 10px 40px 0 40px;
}
.title {
  font-size: 36px;
  font-weight: normal;
  line-height: 50px;
  letter-spacing: 0px;
  color: #333333;
  margin: 20px 0;
}
.btn {
  width: 99%;
  height: 50px;
  border-radius: 5px;
  opacity: 1;
  background: #01afab;
  color: #fff;
}
.smallTit {
  font-size: 24px;
  font-weight: normal;
  line-height: 50px;
  letter-spacing: 0px;
  color: #000000;
  text-align: center;
}
.content {
  font-size: 14px;
  font-weight: normal;
  letter-spacing: 0em;
  color: #444444;
  margin-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/ContactWe.vue